import {
  Button as AntButton,
  Descriptions,
  Modal,
  Table,
  TableColumnsType,
} from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRefundDetail } from '../../../../api/refunds.api';
import useAxios from '../../../../hooks/useAxios';
import { getCommonCodeLabel } from '../../../../lib/store';
import {
  IGetRefundDetail,
  IRefundDetailItem,
} from '../../../../models/refunds.model';
import ErrorResponse from '../../../ErrorResponse';
import Loader from '../../../Loader';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  refundNo: number | undefined;
}

const RefundDetailModal: FC<IProps> = ({
  visible,
  setVisible,
  refundNo,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetRefundDetail>();

  const [data, setData] = useState<any>();

  useEffect(() => {
    if (refundNo) {
      execute(getRefundDetail(refundNo));
    }
  }, [refundNo]);

  useEffect(() => {
    if (res && !isLoading) {
      setData(res.data?.details);
    }
  }, [res, isLoading]);

  const columns: TableColumnsType<IRefundDetailItem> = [
    {
      title: t('common.column.semester'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: 'center',
    },
    {
      title: t('payment.charge.column1'),
      dataIndex: 'monthNameCode',
      key: 'monthNameCode',
      align: 'center',
      render: value => getCommonCodeLabel('SY0009', value?.trim() || '', 'ko'),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: t('payment.refund.column1'),
      dataIndex: 'paymentTargetCode',
      key: 'paymentTargetCode',
      align: 'center',
      render: value => getCommonCodeLabel('PA0001', value, 'ko'),
    },
    {
      title: t('payment.record.column3'),
      dataIndex: 'paymentAmount',
      key: 'paymentAmount',
      align: 'center',
      render: value => value?.toLocaleString(),
    },
    {
      title: t('payment.refund.column2'),
      dataIndex: 'refundAmount',
      key: 'refundAmount',
      align: 'center',
      render: value => value?.toLocaleString(),
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('payment.refund.title2')}
        visible={visible}
        onCancel={() => setVisible(false)}
        width={750}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="primary" className='btn-basic pink' onClick={() => setVisible(false)}>
              {t('common.button.confirm')}
            </AntButton>
          </div>
        ]}
      >
        <div className='comm-table__area rowType mt-0'>
          <Descriptions
            bordered
            size="small"
            column={2}
            labelStyle={{ width: '20%' }}
            contentStyle={{ width: '30%' }}
          >
            <Descriptions.Item label={t('payment.retire.column1')}>
              {res?.data?.memberName}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.refund.column4')}>
              {res?.data?.refundDttm}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.refund.column3')}>
              {getCommonCodeLabel(
                'PA0006',
                res?.data?.calculateReasonCode || '',
                'ko',
              )}
            </Descriptions.Item>
            <Descriptions.Item label={t('payment.refund.column2')}>
              {res?.data?.totalRefundAmount?.toLocaleString()}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <Table
          className='comm-table__area'
          columns={columns}
          dataSource={data}
          pagination={{
            pageSize: 9999999,
          }}
        />
      </Modal>
    </>
  );
};

export default RefundDetailModal;
